import React from 'react';
import { Typography } from '@mui/material';
import { TransactionList } from '../components/TransactionList';

export const TransactionsPage: React.FC = () => {
    document.title = "Duitleh - Transactions";
    return (
        <>
            <Typography variant="h4" gutterBottom>
                Transactions
            </Typography>
            <TransactionList />
        </>
    );
};
